<template>
  <v-layout justify-center pt-2>

    <!-- sticky button-->
    <div class="stickyClass">
      <v-flex layout column align-center>
            <v-btn
              color="white"
              class="text-none primary--text"
              @click="$router.push('/pathManagement/' + pathId)"
            >
            {{ $t('managePath.back') }}
            </v-btn>
      </v-flex>
    </div>

    <v-flex pt-2>
    <v-container >
    <v-card>
  
    <h2>{{ $t('managePath.optionTitle.style') }}</h2>

     <!-- theme colors -->
      <v-layout row pa-2>
        <v-flex layout xs5 >
           <p class="grey--text" v-html="$t('managePath.themeColors')"></p>
        </v-flex>
        <v-flex layout xs7 >
        <v-tooltip right v-model="showTooltipColorPrimary" ref="showTooltipColorPrimary">
            <v-btn
              slot="activator"
              :style="{ backgroundColor: colorPrimary, width: '100px', height: '100px', marginTop: '20px' }"
              >
               <v-icon
                color="red"
                class="deleteColorIcon"
                @click="setColorPrimary(null);updateColor()"
              >
                mdi-close
              </v-icon>
            </v-btn>
          <span 
            @mouseenter="$refs.showTooltipColorPrimary.runDelay('open')" 
            @mouseleave="$refs.showTooltipColorPrimary.runDelay('close');updateColor()">
              <color-picker
                :colorScrap="colorPrimary"
                @changeColor="setColorPrimary"
              />
          </span>
         
        </v-tooltip>

        <!--v-tooltip right v-model="showTooltipColorSecondary" ref="showTooltipColorSecondary">
            <v-btn
              slot="activator"
              :style="{ backgroundColor: colorSecondary, width: '100px', height: '100px', marginTop: '20px' }"
              >
            </v-btn>
          <span 
            @mouseenter="$refs.showTooltipColorSecondary.runDelay('open')" 
            @mouseleave="$refs.showTooltipColorSecondary.runDelay('close');updateColor()">
              <color-picker
                :colorScrap="colorSecondary"
                @changeColor="setColorSecondary"
              />

          </span>
        </v-tooltip-->

        </v-flex>
      </v-layout>
      <v-divider />

      <!-- theme texture  -->
      <v-layout row pa-2>
        <v-flex layout xs5 >
           <p class="grey--text" v-html="$t('managePath.cardTexture')"></p>
        </v-flex>
        <v-flex layout xs7 >
                    
          <v-item-group  v-model="cardTextureTemplate" >
            <v-layout wrap>
            <v-item>
              
              <image-input
                :default="imageCardTexture"
                :showImageInfos="false"
                :type="'texture'"
                :height="174"
                :width="114"
                @change-image-input="onCardTextureImageChange"
                @error="onImageError"
              />
            </v-item>
            
            <v-item
              v-for="(cardTextureTemplate,i) in cardTextureTemplates"
              :key="i"
              :value="cardTextureTemplate"
            >
              <v-card
                slot-scope="{ active, toggle }"
                :style="{
                  border: '5px solid',
                  borderColor: active ? '#009999' : 'white'
                }"
                :class="['ma-2']"
                color="grey-lighten-1"
                height="174"
                width="114"
                @click="toggle"
              >
                <v-img
                  :src="cardTextureTemplate"
                  height="164"
                  width="104"
                />
                
              </v-card>
            </v-item>
            </v-layout>
          </v-item-group>
        </v-flex>
      </v-layout>
      <v-divider />
     
      <!-- cards revealed -->
      <v-layout row pa-2>
        <v-flex layout xs5 >
        <p class="grey--text" v-html="$t('managePath.cardsRevealed')"></p>
        </v-flex>
        <v-flex layout align-center xs7 >
          <v-switch
            color="primary"
            v-model="isCardsRevealed"
          />
        </v-flex>
      </v-layout>
      <v-divider />

      
      <h2>{{ $t('managePath.optionTitle.access') }}</h2>
      <!-- access restriction -->
      <v-layout row pa-2>
        <v-flex layout xs5 >
           <p class="grey--text" v-html="$t('managePath.restrictAccess')"></p>
        </v-flex>
            
       
        <!-- restriction radio group-->
        <v-flex layout xs7 >
          <v-form ref="restrictionForm">
            <v-layout row>
              <v-radio-group
                class="segmented-radio"
                v-model="textRestrictionType"
                :mandatory="false"
                :disabled="textRestrictionType === 'uniqueCode' && path.uniqueCodeCount >0 "
                row
              >
                <v-radio
                  mr-5
                  class="segmented-radio__input"
                  v-for="restrictionType in restrictionTypes"
                  :key="restrictionType"
                  :value="restrictionType"
                >
                  <v-layout slot="label" column>
                    <span v-bind:class="{
                          'segmented-radio--selected':
                            textRestrictionType === restrictionType,
                          'segmented-radio--disabled':
                            textRestrictionType === restrictionType && textRestrictionType === 'uniqueCode' && path.uniqueCodeCount >0 ,
                        }"
                      >{{
                        $t(`managePath.restrictionType.${restrictionType}`)
                      }}
                    </span>
                  </v-layout>
                </v-radio>

              </v-radio-group>
            </v-layout>
          
          <!-- restriction form-->
          <v-layout row justify-center>
            <v-text-field
              style="max-width: 200px"
              v-if="textRestrictionType === 'password'"
              :rules="rules['access']"
              :counter="maxRestriction"
              outline
              single-line
              v-model="textRestrictionValue"
              @blur="updateRestriction()"
            />
            <v-btn v-if="textRestrictionType === 'qrcode'"
              @click="isFlashCodeDialogOpen = !isFlashCodeDialogOpen"
            >
              <v-icon left>mdi-qrcode</v-icon>
              <span>{{ $t('gameFormCard.generateQrcode') }}</span>
            </v-btn>
            <p v-if="textRestrictionType === 'uniqueCode' && !path.uniqueCodeCount">{{$t(`pathForm.restriction.helpers.${textRestrictionType}`)}}</p>
            <p v-else-if="textRestrictionType === 'uniqueCode' && path.uniqueCodeCount >0 ">{{$t("pathManagement.uniqueCodesLeft")}}: {{path.uniqueCodeCount}}</p>
          </v-layout>
          <qr-code-dialog
            :isFlashCodeDialogOpen="isFlashCodeDialogOpen"
            :qrCodeValue="textRestrictionValue"
            :qrCodeName="'pathName'"
            @close-dialog="isFlashCodeDialogOpen = false"
          />
          </v-form>
        </v-flex>
      </v-layout>
      <v-divider />

      <h2>{{ $t('managePath.optionTitle.innerPath') }}</h2>
      
      <!-- mode histoire -->
      <v-layout row pa-2>
        <v-flex layout xs5 >
        <p class="grey--text" v-html="$t('managePath.guidedMode')"></p>
        </v-flex>
        <v-flex layout align-center xs7 >
          <v-switch
            color="primary"
            v-model="isGuided"
          />
        </v-flex>
      </v-layout>
      <v-divider />
     
      <!-- missions bloquées -->
      <v-layout row pa-2>
        <v-flex layout xs5 >
           <p class="grey--text" v-html="$t('managePath.lockMissions')"></p>
        </v-flex>
        <v-flex layout align-center xs7 >
          <v-switch
            color="primary"
            v-model="lockMissions"
          />
        </v-flex>
      </v-layout>
      <v-divider />

      <!-- mission order radio group-->
      <v-layout row pa-2>
        <v-flex layout xs5 >
           <p class="grey--text" v-html="$t('managePath.missionsOrder')"></p>
        </v-flex>
        <v-flex layout xs7 >
          <v-form ref="missionOrderForm">
            <v-layout row>
              <v-radio-group
                class="segmented-radio"
                v-model="textMissionOrderType"
                :mandatory="false"
                row
              >
                <v-radio
                  mr-5
                  class="segmented-radio__input"
                  v-for="missionOrderType in missionOrderTypes"
                  :key="missionOrderType"
                  :value="missionOrderType"
                  :color="missionOrderType === textMissionOrderType ? 'primary' : ''"
                  
                >
                  <v-layout slot="label" column>
                    <span v-bind:class="{
                          'segmented-radio--selected':
                            textMissionOrderType === missionOrderType,
                        }"
                      >{{
                        $t(`managePath.missionOrderType.${missionOrderType}.title`)
                      }}
                    </span>
                  </v-layout>
                </v-radio>

              </v-radio-group>
            </v-layout>
          
          <!-- missionOrder legend -->
          <v-layout row justify-center>
              <span>{{ $t(`managePath.missionOrderType.${textMissionOrderType}.legend`)}}</span>
            
          </v-layout>
          
          <!-- missionOrder options -->
          <v-layout row v-if="textMissionOrderType!=='order'">
              <v-checkbox
                v-model="lockFirstMission"
                :label="$t('managePath.lockFirstMission')"
                color="primary"
              />
              <v-checkbox 
                v-if="path.missions.length > 1"
                v-model="lockLastMission"
                :label="$t('managePath.lockLastMission')"
                color="primary"
              />
            
          </v-layout>
          
          </v-form>
        </v-flex>
      </v-layout>
      <v-divider />

      <!-- mission order btn-toggle 
      <v-layout row pa-2>
        <v-flex layout xs5 >
           <p class="grey--text" v-html="$t('managePath.missionsOrder')"></p>
        </v-flex>
        <v-flex layout xs7 >
          <v-btn-toggle v-model="textMissionOrderType" mandatory>
            <v-btn flat 
              v-for="missionOrderType in missionOrderTypes"
              :key="missionOrderType"
              :value="missionOrderType"
              >
              
                  {{
                      $t(`managePath.missionOrderType.${missionOrderType}.title`)
                    }}
                
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
      <v-divider />-->

     
      
      <h2>{{ $t('managePath.optionTitle.map') }}</h2>
      
      <!-- afficher la carto -->
      <v-layout row pa-2>
        <v-flex layout xs5 >
           <p class="grey--text" v-html="$t('managePath.mapAvailable')"></p>
        </v-flex>
        <v-flex layout align-center xs7 >
          <v-switch
            color="primary"
            v-model="isMapAvailable"
          />
        </v-flex>
      </v-layout>
      <v-divider />

      <!-- changer la carto en image -->
      <v-layout row pa-2>
        <v-flex layout xs5 >
           <p class="grey--text" v-html="$t('managePath.imageAsMap')"></p>
        </v-flex>
        <v-flex layout align-center xs7 >
          
          <image-input
            :default="imageAsMap"
            :showImageInfos="false"
            :type="'mapPlan'"
            @change-image-input="onImageAsMapChange"
            @error="onImageError"
          />
          </v-flex>
      </v-layout>
      <v-divider />

      <!-- trace GPX -->
      <v-layout row pa-2>
        <v-flex layout xs5 >
           <p class="grey--text" v-html="$t('managePath.trace')"></p>
        </v-flex>
        <v-flex layout xs7 >
          <v-layout row wrap justify-center>
          <v-flex>
            <trace-input
              @get-trace="changeTrace">
            </trace-input>
            
              <location-picker v-if="trace"
                
                :pathTrace="trace"
                :defaultRadius="3"
                :zoomOnClick="17"
                :parent="'managePath'"
              />
          </v-flex>
          </v-layout>

        </v-flex>
      </v-layout>
      <v-divider />

      <h2>{{ $t('managePath.optionTitle.other') }}</h2>

       <!-- temps réel 
      <v-layout row pa-2>
        <v-flex layout xs5 >
           <p class="grey--text" v-html="$t('managePath.realTime')"></p>
        </v-flex>
        <v-flex layout align-center xs7 >
          <v-switch
            color="primary"
            v-model="isRealtime"
          />
        </v-flex>
      </v-layout>
      <v-divider />
      -->

      <!-- +18 ans -->
      <v-layout row pa-2>
        <v-flex layout xs5 >
           <p class="grey--text" v-html="$t('managePath.restrictedToAdults')"></p>
        </v-flex>
        <v-flex layout align-center xs7 >
          <v-switch
            color="primary"
            v-model="isRestrictedToAdults"
          />
        </v-flex>
      </v-layout>
      <v-divider />



      </v-card>
        </v-container>
      </v-flex>
    </v-layout>
</template>

<script>
import textDialog from '../components/TextDialog';
import QrCodeDialog from '../components/QrCodeDialog.vue';
import ColorPicker from '../components/ColorPicker.vue';
import ImageInput from '../components/ImageInput';
import TraceInput from '../components/TraceInput';
import LocationPicker from '../components/LocationPicker.vue';
 
export default {
  components: {
    textDialog,
    QrCodeDialog,
    ColorPicker,
    ImageInput,
    TraceInput,
    LocationPicker,
  },
  data() {
    return {
      isGuided: false,
      isRealtime: false,
      isMapAvailable: true,
      isRestrictedToAdults: false,
      isCardsRevealed: false,
      lockMissions: false,
      isTextDialogOpen: false,
      isColorPickerOpen: false,
      showTooltipColorSecondary: false,
      showTooltipColorPrimary: false,
      typeTextDialog: '',
      textRestrictionValue: '',
      textRestrictionType: 'norestrictions',
      restrictionTypes: ['norestrictions', 'password', 'qrcode', 'uniqueCode'],
      restrictionIcon: {
        password: 'mdi-dots-horizontal', // 'mdi-textbox-password',
        qrcode: 'mdi-qrcode-scan',
        uniqueCode: 'mdi-dots-scan',
        norestrictions: 'mdi-lock-open-outline',
      },
      maxRestriction: 60,
      isFlashCodeDialogOpen: false,
      textMissionOrderType: 'order',
      missionOrderTypes: ['order', 'randomStart', 'randomOrder'],
      colorFieldName: null,
      color: null,
      colorPrimary: null,
      colorSecondary: null,
      timeout: null,
      imageCardTexture: { url: '', author: '', legend: { fr: '', en: '' } },
      imageAsMap: { url: '', author: '', legend: { fr: '', en: '' } },
      imageError: null,
      errorMessage: '',
      cardTextureTemplate: null,
      cardTextureTemplates:[
        "https://explorama-prod.s3.eu-west-3.amazonaws.com/contentPictures/explorama-texturecard1.jpg",
        "https://explorama-prod.s3.eu-west-3.amazonaws.com/contentPictures/explorama-texturecard2.jpg",
        "https://explorama-prod.s3.eu-west-3.amazonaws.com/contentPictures/explorama-texturecard3.jpg",
        "https://explorama-prod.s3.eu-west-3.amazonaws.com/contentPictures/explorama-texturecard4.jpg",
        "https://explorama-prod.s3.eu-west-3.amazonaws.com/contentPictures/explorama-texturecard5.jpg"
      ],
      lockFirstMission:false,
      lockLastMission:false,
      trace: null,
      rules: {
        access: [
          (restriction) =>
            (restriction && restriction.length !== 0) ||
            this.$t('managePath.textDialogInformations.access.errors.empty'),
          (restriction) =>
            (restriction && restriction.length <= this.maxRestriction) ||
            this.$tc(
              'managePath.textDialogInformations.access.errors.length',
              this.maxRestriction
            ),
        ],
      }
    };
  },
  created() {
    //this.setPath();
    if (this.path.isGuided) {
      this.isGuided = this.path.isGuided;
    }
    if (this.path.isRealtime) {
      this.isRealtime = this.path.isRealtime;
    }
    if (this.path.isMapAvailable) {
      this.isMapAvailable = this.path.isMapAvailable;
    }
    if (this.path.isRestrictedToAdults) {
      this.isRestrictedToAdults = this.path.isRestrictedToAdults;
    }
    if (this.path.tags && this.path.tags.includes("cardsRevealed")) {
      this.isCardsRevealed = true;
    }
    if (this.path.lockMissions) {
      this.lockMissions = this.path.lockMissions;
    }
    if (this.restrictionType) {
      this.textRestrictionType = this.restrictionType;
      this.textRestrictionValue = this.restrictionValue;
    }
    if (this.path.randomStart) {
      this.textMissionOrderType = "randomStart";
    }
    else if (this.path.randomOrder) {
      this.textMissionOrderType = "randomOrder";
    }
    if (this.path.colorPrimary) {
      this.colorPrimary = this.path.colorPrimary;
    }
    if (this.path.colorSecondary) {
      this.colorSecondary = this.path.colorSecondary;
    }
    if (this.path.cardTextureUrl) {
      let templateFound = this.cardTextureTemplates.find(t=> t === this.path.cardTextureUrl)
      if (!templateFound) {
        this.cardTextureTemplates.unshift(this.path.cardTextureUrl);
        this.cardTextureTemplate = this.path.cardTextureUrl
      } else {
        this.cardTextureTemplate = templateFound
      }
    }
    if (this.path.mapPictureUrl) {
      this.imageAsMap.url = this.path.mapPictureUrl;
    }
    if (this.path.trace) {
      this.trace = {latlngs: this.path.trace.coordinates};
    }
    if (this.path.traceProperties) {
      this.trace.properties = this.path.traceProperties
    }
    if (this.firstMission.isFixed) {
      this.lockFirstMission = this.firstMission.isFixed;
    }
     if (this.lastMission.isFixed) {
      this.lockLastMission = this.lastMission.isFixed;
    }
  },
  watch: {
    //pathId(newValue) {
    //  this.setPath();
    //  return newValue;
    //},
    async isGuided(newValue, oldValue) {
      if (oldValue === null || newValue === this.path.isGuided) {
        return;
      }
      const payload = { isGuided: newValue };
      await this.updatePath(payload);
    },
    async isRealtime(newValue, oldValue) {
      if (oldValue === null || newValue === this.path.isRealtime) {
        return;
      }
      const payload = { isRealtime: newValue };
      await this.updatePath(payload);
    },
    async isMapAvailable(newValue, oldValue) {
      if (oldValue === null || newValue === this.path.isMapAvailable) {
        return;
      }
      const payload = { isMapAvailable: newValue };
      await this.updatePath(payload);
    },
    async isRestrictedToAdults(newValue, oldValue) {
      if (oldValue === null || newValue === this.path.isRestrictedToAdults) {
        return;
      }
      const payload = { isRestrictedToAdults: newValue };
      await this.updatePath(payload);
    },
    async isCardsRevealed(newValue, oldValue) {
      const tags = this.path.tags || null
      console.log("card rev", tags, oldValue, newValue)
      
      if (oldValue === null || 
      (tags && tags.includes("cardsRevealed") && newValue === tags.includes("cardsRevealed"))) {
        return;
      }
      let payload = {} 
      if (tags && newValue===true) payload= {tags:[...tags, "cardsRevealed"]} ;
      else if (tags && newValue===false) payload= {tags:tags.filter(item => item !== "cardsRevealed")} ;
      else payload = {tags:["cardsRevealed"]} ;
      console.log("payload",payload)
      await this.updatePath(payload);
    },
    async lockMissions(newValue, oldValue) {
      if (oldValue === null || newValue === this.path.lockMissions) {
        return;
      }
      const payload = { lockMissions: newValue };
      await this.updatePath(payload);
    },
    lockFirstMission(newValue, oldValue) {
      if (oldValue === null || newValue === this.firstMission.isFixed) {
        return;
      }
      this.updateLockMissions();
    },
    lockLastMission(newValue, oldValue) {
      if (oldValue === null || newValue === this.lastMission.isFixed) {
        return;
      }
      this.updateLockMissions();
    },
    textRestrictionType(val) {
      if (val === 'qrcode') {
        this.textRestrictionValue = `https://explorama.app/play/${this.pathId}`;
      }
      if (val === 'uniqueCode') {
        this.textRestrictionValue = null
      }
      this.updateRestriction();
    },
    textMissionOrderType(newValue, oldValue) {
      if (oldValue === null || 
        ( newValue === 'randomOrder' && this.path.randomOrder === true) ||
        ( newValue === 'randomStart' && this.path.randomStart === true)
        ) {
        return;
      }
      this.updateMissionOrder(newValue);
    },
    cardTextureTemplate(newValue, oldValue) {
      if ( newValue === this.path.cardTextureUrl) {
        return;
      }
      this.updateCardTextureImage();
    }
    
  },
  computed: {
    pathId() {
      return this.$route.params.pathId || null;
    },
    path() {
      return this.$store.getters['paths/getPathById'](this.pathId);
    },
    restrictionType() {
      return this.path.restriction && this.path.restriction.type;
    },
    restrictionValue() {
      return this.path.restriction && this.path.restriction.value;
    },
    validRestrictionForm() {
      if (
        (this.textRestrictionValue &&
          this.textRestrictionValue.length !== 0 &&
          this.textRestrictionValue.length <= this.maxRestriction &&
          this.textRestrictionType &&
          this.textRestrictionType !== '') ||
        this.textRestrictionType === 'norestrictions' ||
        this.textRestrictionType === 'uniqueCode'
      ) {
        return true;
      }
      return false;
    },
    firstMission() {
      return this.path.missions[0]
    },
    lastMission() {
      return this.path.missions[this.path.missions.length-1]
    },
    textDialogInformations() {
      return {
        access: {
          title: this.$t('managePath.textDialogInformations.access.title'),
          explanation: this.$t(
            'managePath.textDialogInformations.access.explanation'
          ),
          //details: this.$t('managePath.textDialogInformations.access.details'),
          cancelButtonText: this.$t(
            'managePath.textDialogInformations.access.cancelButtonText'
          ),
          confirmButtonText: this.$t(
            'managePath.textDialogInformations.access.confirmButtonText'
          ),
          confirmButtonColor: 'primary',
        },
      };
    },
  },
  
  methods: {
    openTextDialog(type) {
      this.typeTextDialog = type;
      this.isTextDialogOpen = true;
    },
    cancelTextDialog() {
      this.typeTextDialog = '';
      this.isTextDialogOpen = false;
    },
    updateRestriction(val) {
      let pathPayload;
      if (!this.validRestrictionForm) return;
      if (this.textRestrictionType === 'norestrictions') {
        pathPayload = { restriction: null };
      } else {
        pathPayload = {
          restriction: {
            type: this.textRestrictionType,
            value: this.textRestrictionValue,
          },
        };
      }
      this.updatePath(pathPayload);
    },
    updateMissionOrder(val) {
      let pathPayload ;
      if (this.textMissionOrderType === 'order') {
        pathPayload = {
          randomStart: false, 
          randomOrder: false 
        }
      } else if (this.textMissionOrderType === 'randomStart') {
        pathPayload = {
          randomStart: true, 
          randomOrder: false 
        }
      } else {
        pathPayload = {
          randomStart: false, 
          randomOrder: true 
        }
      }
      this.updatePath(pathPayload);
    },
    setColorPrimary(color) {
      this.colorPrimary = color
      this.colorFieldName = "colorPrimary"
    },
    setColorSecondary(color) {
      this.colorSecondary = color
      this.colorFieldName = "colorSecondary"
    },
    updateColor() {
      // save color on close
      let pathPayload = { [this.colorFieldName]: this[this.colorFieldName] }
      this.updatePath(pathPayload);
    },
    onCardTextureImageChange(image) {
      if (this.imageCardTexture !== image) {
        this.imageCardTexture = image;
        this.cardTextureTemplates.unshift(this.imageCardTexture.url);
        this.cardTextureTemplate = this.imageCardTexture.url
      }
    },
    onImageAsMapChange(image) {
      if (this.imageAsMap !== image) {
        this.imageAsMap = image;
        let payload = { mapPictureUrl: this.imageAsMap.url };
        this.updatePath(payload);
      }
    },
    onImageError(error) {
      this.imageError = error.message;
      this.$toast.show(this.imageError);
    },
    updateCardTextureImage(value) {
      let cardTextureTemplate = null
      if (typeof this.cardTextureTemplate !== 'undefined') cardTextureTemplate = this.cardTextureTemplate
      let payload = { cardTextureUrl: cardTextureTemplate };
      this.updatePath(payload);
    },
    changeTrace(geojson) {
      // Retirer l'élévation 
      geojson.features[0].geometry.coordinates = geojson.features[0].geometry.coordinates.map((coord) => {
        return [coord[0], coord[1]]; 
      });
      // ajouter [] pour multilinestring
      this.trace = {
        latlngs: [geojson.features[0].geometry.coordinates],
        properties: geojson.features[0].properties,
      }
      this.updateTrace()
    },
    updateTrace() {
      let payload = { 
        trace: {
          coordinates: this.trace.latlngs,
          type: 'multilinestring'
        },
        traceProperties: this.trace.properties,
      };
      this.updatePath(payload);
    },
    updateLockMissions() {
      const pathMissions = JSON.parse(JSON.stringify(this.path.missions))
      pathMissions[0].isFixed = this.lockFirstMission
      if (this.path.missions.length > 1) {
        pathMissions[pathMissions.length-1].isFixed = this.lockLastMission
      }
      let payload = { missions: pathMissions };
      console.log('payload', payload)
      this.updatePath(payload);
    },
    async updatePath(payload) {
      console.log('update path', payload);
      await this.$store.commit('app/SET_LOADING');
      try {
        await this.$store.dispatch('paths/UPDATE_PATH', {
          pathId: this.pathId,
          pathPayload: payload,
          index: this.$store.getters['auth/currentUserIndex'],
          kuzzle: this.$kuzzle,
        });
      } catch (error) {
        console.error(error.message);
      }
      await this.$store.commit('app/UNSET_LOADING');
      this.cancelTextDialog();
    },
  },
};
</script>

<style lang="sass" >
@import '../assets/_vars.scss'
@import '../assets/style.scss'

.manageTitle
  font-size: medium
  padding-left: 5px

.deleteColorIcon
  max-width: 20px;
  margin-bottom: 100px;
  margin-left: 110px;

.segmented-radio 
  display: inline
  label span 
    padding: 0.5em 1em 0.5em 1em
    border: 2px  solid #dfdfdf 
    background: white 
    position: relative
    z-index: 5
    &:hover
      background: #ddd

.segmented-radio .segmented-radio__input:first-child span
  border-radius: 1em 0 0 1em
  border-width: 2px 0 2px 2px

.segmented-radio .segmented-radio__input:last-child span
  border-radius: 0 1em 1em 0
  border-width: 2px 2px 2px 0


.segmented-radio__input
  margin-right: 0px !important


.segmented-radio .v-input--selection-controls__input
  display: none !important

.segmented-radio--selected
  background: $primary !important

.segmented-radio--disabled
  background: #e9e9e9 !important

.v-input--selection-controls
  margin-top: 0px
  margin-left: 16px


.stickyClass
  position: -webkit-sticky;
  position: sticky;
  top: 100px;
  width: 130px;
  height: 0px;
  z-index: 100
</style>
